import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import Text from "@shared/components/ui-kit/typography/Text/Text.web";
import { useTranslation } from "@shared/utils/internationalization";

interface DonationsHeaderProps {
  hideTitle?: boolean;
}

export default function DonationsHeader(props: DonationsHeaderProps) {
  const { hideTitle } = props;
  const { t } = useTranslation("common");

  return (
    <>
      {!hideTitle && (
        <Box width="100%" maxWidth="100%">
          <Text
            fontSize={{ base: "md", sm: "lg" }}
            fontWeight="bold"
            color="primary.600"
          >
            {t("Donation")}
          </Text>
        </Box>
      )}
    </>
  );
}
